<template>
  <FormGroup v-bind="{ topHelpText, optional, link, name, label, helpText, error }">
    <LuiInput
      v-bind="inputAttrs"
      :id="name"
      ref="input"
      type="email"
      :placeholder="label"
      :model-value="value"
      @update:model-value="$emit('update:value', $event)"
    />
  </FormGroup>
</template>

<script setup lang="ts">
import { LuiInput } from '@loomispay/loomis-ui'
import { type Ref, ref } from 'vue'
import type { ComponentExposed } from 'vue-component-type-helpers'

import type { FormGroupProps } from '@/interfaces/Frontend/FormGroup'

import FormGroup from '@/components/FormGroups/Block/BlockFormGroup.vue'
import { useFormGroup } from '@/composables/useFormGroup'

interface Props extends FormGroupProps {
  value?: string
  inputAttrs?: Record<string, unknown>
}

const props = withDefaults(defineProps<Props>(), {
  value: undefined,
  inputAttrs: () => ({}),
})

defineEmits<{
  'update:value': [string]
}>()

const input = ref<ComponentExposed<typeof LuiInput> | null>(null)

useFormGroup(props, input as Ref<HTMLElement | null>)
</script>
